import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import TrainerDetail from '@/components/common/Trainer/TrainerDetail';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { GET_USER_BY_ID } from '@/Graphql/queries';
import { useQuery } from '@apollo/client';
import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const TrainerDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { data, loading } = useQuery(GET_USER_BY_ID, {
    variables: {
      id: id || '',
    },
    skip: !id,
  });

  const handleGoBack = () => {
    if (location.key === 'default') {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className='w-full  flex flex-col overflow-auto'>
      <HeaderWrapper className='fixed w-full top-0 z-50 flex-col md:flex-row gap-2'>
        <div className='flex w-full items-center gap-2'>
          <Button
            onClick={handleGoBack}
            id='session-details-back-btn'
            variant='ghost'
            size='icon'
            className='text-white'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
          <h1 className='text-lg font-semibold'>
            {loading ? (
              <Skeleton className='w-32 h-4 bg-bgSecondary' />
            ) : !data?.getUserById ? (
              'User not found'
            ) : data?.getUserById?.firstName ? (
              data?.getUserById?.firstName
            ) : (
              ''
            )}
          </h1>
        </div>
      </HeaderWrapper>
      <div className='mx-auto w-[1060px] max-w-[98%] h-full mt-28 mb-16'>
        <TrainerDetail trainerData={data || null} loading={loading} />
      </div>
    </div>
  );
};

export default TrainerDetails;
